var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89746 0C4.92946 0 0.897461 4.032 0.897461 9C0.897461 13.968 4.92946 18 9.89746 18C14.8655 18 18.8975 13.968 18.8975 9C18.8975 4.032 14.8655 0 9.89746 0ZM10.7975 15.3H8.99746V13.5H10.7975V15.3ZM12.6605 8.325L11.8505 9.153C11.2025 9.81 10.7975 10.35 10.7975 11.7H8.99746V11.25C8.99746 10.26 9.40246 9.36 10.0505 8.703L11.1665 7.569C11.4995 7.245 11.6975 6.795 11.6975 6.3C11.6975 5.31 10.8875 4.5 9.89746 4.5C8.90746 4.5 8.09746 5.31 8.09746 6.3H6.29746C6.29746 4.311 7.90846 2.7 9.89746 2.7C11.8865 2.7 13.4975 4.311 13.4975 6.3C13.4975 7.092 13.1735 7.812 12.6605 8.325Z",
    fill: "#6D6D74"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.18411819f42e31a2c52e5f883918dd01.svg";
export { ForwardRef as ReactComponent };